module.exports = __webpack_public_path__ + "static/media/ferianavidad.8555047b.jpg";